(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brc-nav-product"]) return;
  try {
    
  document.addEventListener('click', function(event) {
    var backButton = event.target.closest('[data-breadcrumb-history-back]');
    if (!backButton) return;

    if (window.history.length > 1) {
      window.history.back();
      return;
    }

    window.location.href = backButton.getAttribute('data-fallback-url') || '/collections';
  });

  } catch(e) { console.error(e); }
})();
})();
